<div class="modal-content modal-theme2">
  <div class="modal-header">
    <h4 class="modal-title">Account Required</h4>
    <button
      aria-label="Close"
      aria-label="Close"
      type="button"
      class="btn-close close pull-right btn-login-close"
      aria-label="Close"
      (click)="onCloseClick()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body d-flex justify-content-center">
    <p>Please Sign In or Create New Account</p>
  </div>
  <div class="modal-footer pb-4 gap-3">
    <button
      (click)="redirectTo(true)"
      class="btn btn-default  mb-2"
      type="button"
    >
      Sign in
    </button>
    <button
      (click)="redirectTo(false)"
      class="btn btn-primary mb-2"
      type="button"
    >
      Create New Account
    </button>
  </div>
</div>
